<template>
  <section class="main-section page-rendez-vous">
    <!-- Rendez-vous (Accueil / Caisse) : agenda et demandes faites en ligne sur les sites des clients Clinicaa (04/10/2026). -->
    <div class="row mb-2">
      <div class="col-lg-12 pdlr-x">
        <div class="animate animate-fadeInLeft">
          <h1 class="p-title">Rendez-vous</h1>
          <p class="p-subtitle">Retrouvez l’agenda de l’établissement et les demandes de rendez-vous reçues en ligne.</p>
        </div>
      </div>
    </div>
    <div v-if="rdvWebActif" class="prv-onglets" role="tablist" aria-label="Rendez-vous">
      <button type="button" role="tab" :aria-selected="vue === 'agenda' ? 'true' : 'false'" :class="{ actif: vue === 'agenda' }" @click="choisir('agenda')">Agenda</button>
      <button type="button" role="tab" :aria-selected="vue === 'demandes' ? 'true' : 'false'" :class="{ actif: vue === 'demandes' }" @click="choisir('demandes')">
        Demandes des sites<span v-if="enAttente" class="prv-compteur" :aria-label="enAttente + ' en attente'">{{ enAttente }}</span>
      </button>
    </div>
    <AgendaRendezVous v-if="vue === 'agenda'" />
    <DemandesSites v-else @compteur="nombre => { enAttente = nombre }" />
  </section>
</template>

<script>
import AgendaRendezVous from '@/components/rendez-vous/agenda-rendez-vous'
import DemandesSites from '@/components/rendez-vous/demandes-sites/index.vue'
import api_rdv from '@/api/clinique/_rendez_vous'
import { rdvWebActif } from '@/utils/rdv-web'

export default {
  name: 'page-rendez-vous',
  components: { AgendaRendezVous, DemandesSites },
  data() {
    // Sans RDV_WEB_ENABLED: true dans public/env.json : agenda seul, sans onglet ni appel aux demandes des sites.
    const actif = rdvWebActif()
    return { rdvWebActif: actif, vue: actif && this.$route && this.$route.query.vue === 'demandes' ? 'demandes' : 'agenda', enAttente: 0 }
  },
  mounted() {
    if (this.vue === 'agenda') this.compter()
  },
  methods: {
    choisir(vue) {
      this.vue = vue
      if (this.$router && this.$route && (this.$route.query.vue || 'agenda') !== vue) {
        this.$router.replace({ path: this.$route.path, query: vue === 'demandes' ? { vue } : {} }).catch(() => {})
      }
      if (vue === 'agenda') this.compter()
    },
    // Nombre de demandes en attente, affiché sur l'onglet ; silencieux si les demandes en ligne ne sont pas activées.
    async compter() {
      if (!this.rdvWebActif) return
      try {
        const acces = await api_rdv.access()
        const reponse = await api_rdv.demandesSites({ status: 'en_attente', page: 1 }, acces.access_token)
        this.enAttente = (reponse && reponse.total) || 0
      } catch (erreur) {
        this.enAttente = 0
      }
    },
  },
}
</script>

<style scoped>
.page-rendez-vous { color: #172033 }
.page-rendez-vous .p-title { color: #172033; margin-bottom: 8px }
.page-rendez-vous .p-subtitle { color: var(--ui-text, #374151); font-size: 15px; line-height: 1.6; max-width: 800px }
.prv-onglets { display: flex; gap: 6px; flex-wrap: wrap; width: fit-content; padding: 5px; margin: 8px 0 20px; background: #fff; border: 1px solid #dce4f1; border-radius: 16px }
.prv-onglets button { border: 0; background: transparent; padding: 10px 18px; font-weight: 600; font-size: 15px; color: #172033; border-radius: 11px; min-height: 42px }
.prv-onglets button.actif { color: #173e9b; background: #eaf0ff }
.prv-onglets button:hover { background: #f1f5fb }
.prv-onglets button:focus-visible { outline: 3px solid #8caaf5; outline-offset: 2px }
.prv-compteur { display: inline-block; min-width: 22px; margin-left: 8px; padding: 0 7px; border-radius: 999px; background: #e5484d; color: #fff; font-size: 12px; line-height: 20px; text-align: center }
/* L'agenda garde son fonctionnement ; son titre est celui de la page, au-dessus des onglets. */
.page-rendez-vous ::v-deep .agenda-rendez-vous.main-section { padding-top: 0 }
.page-rendez-vous ::v-deep .agenda-rendez-vous > .row.mb-3:first-child { display: none }
</style>
